<div class="atp">
  <header class="atp-head">
    <button type="button" class="atp-close" (click)="cancel()" aria-label="Close">
      <i class="bx bx-x" aria-hidden="true"></i>
    </button>
    <h2 class="atp-title">Set PIN</h2>
    <div class="atp-actions">
      <button type="button" class="atp-cancel" (click)="cancel()">Cancel</button>
      <button type="button" class="atp-save" [disabled]="!isFormValid" (click)="save()">
        Save PIN
      </button>
    </div>
  </header>

  <div class="atp-body">
    <section class="atp-card">
      <header class="atp-card-head">
        <span class="atp-card-icon"><i class="bx bx-shield-quarter" aria-hidden="true"></i></span>
        <div class="atp-card-headings">
          <h3 class="atp-card-title">Device Access PIN</h3>
          <p class="atp-card-sub">Set a 6-digit PIN for this staff member to access POS devices</p>
        </div>
      </header>

      <label class="atp-label" for="newPin0">New PIN *</label>
      <div class="spf-row">
        <div class="spf-boxes">
          @for (i of pinIndices; track i) {
            <input
              [id]="'newPin' + i"
              class="spf-box"
              [type]="showNewPin ? 'text' : 'password'"
              [value]="newPinDigits[i]"
              maxlength="1"
              inputmode="numeric"
              autocomplete="off"
              [attr.aria-label]="'New PIN digit ' + (i + 1)"
              (input)="onPinDigitInput('new', i, $event)"
              (keydown)="onPinKeydown('new', i, $event)"
              (paste)="onPinPaste('new', $event)"
            />
          }
        </div>
        <button
          type="button"
          class="spf-eye"
          [class.spf-eye--on]="showNewPin"
          (click)="toggleShowNewPin()"
          [attr.aria-label]="showNewPin ? 'Hide new PIN' : 'Show new PIN'"
          [attr.aria-pressed]="showNewPin"
        >
          <i [class]="showNewPin ? 'bx bx-show' : 'bx bx-hide'" aria-hidden="true"></i>
        </button>
      </div>
      <p class="atp-help">Enter a 6-digit numeric PIN</p>

      <label class="atp-label atp-label--spaced" for="confirmPin0">Confirm PIN *</label>
      <div class="spf-row">
        <div class="spf-boxes" [class.spf-boxes--error]="confirmPinError">
          @for (i of pinIndices; track i) {
            <input
              [id]="'confirmPin' + i"
              class="spf-box"
              [type]="showConfirmPin ? 'text' : 'password'"
              [value]="confirmPinDigits[i]"
              maxlength="1"
              inputmode="numeric"
              autocomplete="off"
              [attr.aria-label]="'Confirm PIN digit ' + (i + 1)"
              (input)="onPinDigitInput('confirm', i, $event)"
              (keydown)="onPinKeydown('confirm', i, $event)"
              (paste)="onPinPaste('confirm', $event)"
            />
          }
        </div>
        <button
          type="button"
          class="spf-eye"
          [class.spf-eye--on]="showConfirmPin"
          (click)="toggleShowConfirmPin()"
          [attr.aria-label]="showConfirmPin ? 'Hide confirmation PIN' : 'Show confirmation PIN'"
          [attr.aria-pressed]="showConfirmPin"
        >
          <i [class]="showConfirmPin ? 'bx bx-show' : 'bx bx-hide'" aria-hidden="true"></i>
        </button>
      </div>
      <p class="atp-help">Re-enter the PIN to confirm</p>
      @if (confirmPinError) {
        <div class="d-flex mt-2 errorText gap-2">
          <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
          <p>New PIN and confirmation PIN do not match. Please try again.</p>
        </div>
      }

      <div class="spf-note">
        <i class="bx bx-error-circle" aria-hidden="true"></i>
        <p>
          This PIN will be used by the staff member to log in to POS terminals and devices. Share it
          securely with the staff member.
        </p>
      </div>
    </section>
  </div>
</div>
